module.exports = __webpack_public_path__ + "assets/img/gar5-4.6bdf546a.jpg";